var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"redirect-if-no-permission",rawName:"v-redirect-if-no-permission:LOCATIONS",arg:"LOCATIONS"}]},[_c('DataTable',{attrs:{"url":_vm.api.ACTIONS.LOCATION_CONTAINERS,"fieldsHiddenMain":["deleted_at"],"titles":_vm.titles,"actionsExtraMain":_vm.actionsExtraMain,"formatter":_vm.formatter,"title":"Containers"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }